<template>
    <router-view />
</template>
<script lang="js">
import '@/assets/styles/global.css';
import { useHead } from '@vueuse/head';
import { defineComponent } from "vue";
export default defineComponent({
    setup() {
        useHead({
            meta: [
                  { name: 'charset', content: 'UTF-8' },
                  { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1' },
                  { name: 'keywords', content: '스카이코드, skycode, sbox, 스터디박스' },
              ],
        });
    }
});
</script>
<style>

</style>
